module.exports = __webpack_public_path__ + "media/src/paywalls/google_classroom_logo-a6628862a09baad295f852deebe20991.svg";